import {combineReducers} from '@reduxjs/toolkit';
import getExportRequestListReducer from './get-export-request-list';

const exportRequestReducer = combineReducers({
  getExportRequestList: getExportRequestListReducer,
});

export default exportRequestReducer;
